export const WHITE = "#ffffff"
export const DARK_BLUE = "#161466"
export const CLOUDY_BLUE = "#b9b8d1"
export const NORMAL_BLUE = "#2460d8"
export const PALE_GREY = "#f8f9fe"
export const VERY_LIGHT_BLUE = "#e2e9fb"
